import { render, staticRenderFns } from "./NewslettersShow.vue?vue&type=template&id=303abcf4&"
import script from "./NewslettersShow.vue?vue&type=script&lang=js&"
export * from "./NewslettersShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports